export default __webpack_public_path__ + "static/media/daraz-logo.fed35f12.png";